(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/collections/result-months.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/collections/result-months.js');

'use strict';

svs.numbergames.results.collections.ResultMonths = svs.numbergames.core.NumbergamesCollection.extend({
  model: svs.numbergames.results.models.ResultMonth,
  comparator(a, b) {
    if (b.get('year') === a.get('year')) {
      return b.get('month') - a.get('month');
    }
    return b.get('year') - a.get('year');
  },
  fetchDrawByDate(date, productId) {
    let {
      context,
      success
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    date = svs.numbergames.results.parsers.datePicker.createDate(date);
    const options = {
      context,
      success: model => {
        let draw = model.getDrawByDate(date.getDate());
        draw = draw || model.getLatestDraw();
        if (typeof success === 'function') success.call(context, draw);
      }
    };
    this.fetchMonth(date.getMonth(), date.getFullYear(), productId, options);
  },
  fetchMonth(month, year, productId) {
    let {
      context,
      success,
      error
    } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const model = this.findWhere({
      month,
      year
    });
    if (model) {
      if (typeof success === 'function') success.call(context, model);
    } else {
      this.create({
        month,
        year,
        productId
      }, {
        wait: true,
        context,
        success,
        error
      });
    }
  },
  getAvailableDates() {
    const dates = [];
    this.forEach(model => dates.push(...model.getAvailableDates()));
    return dates;
  },
  getDrawByDate(date) {
    date = svs.numbergames.results.parsers.datePicker.createDate(date);
    const model = this.findWhere({
      month: date.getMonth(),
      year: date.getFullYear()
    });
    if (model) {
      return model.getDrawByDate(date.getDate());
    }
  }
});

 })(window);